import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'

import install from '@/components/install'
Vue.use(install)

import '@/utils/rem'

// 弹出框的时候滚动条隐藏和出现导致页面抖动问题
ElementUI.Dialog.props.lockScroll.default = false

import Carousel3d from 'vue-carousel-3d'
Vue.use(Carousel3d)

Vue.use(ElementUI)
import CardBox from '@/components/CardBox.vue'
Vue.component('card-box', CardBox)

Vue.prototype.filePrefix = function (val) {
  if (val && val.includes('http')) {
    return val
  }
  return process.env.VUE_APP_FILE_URL + val
}

import ImageUpload from '@/components/ImageUpload/index.vue'
Vue.component('image-upload', ImageUpload)

import windowSizeMixin from '@/mixins/resize'

Vue.mixin(windowSizeMixin)

import util from '@/utils/util.js'
Vue.prototype.$util = util

import { download } from '@/utils/http'
Vue.prototype.download = download

import { i18n } from '@/utils/i18n/index.js'

Vue.config.productionTip = false

const vueInstance = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

export default vueInstance
